module.exports = __webpack_public_path__ + "static/Olark-6eae454e1428ca9715d509c37b653ee2.png";